import { styled } from 'baseui'

export const BarList = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.375rem',
  flexGrow: 1,
  minWidth: '15rem',
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: 0,
  listStyleType: 'none',
})
